import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetReservationsRegularBySearch(club, url) {

  var url = "/reservation/get_club_reservation_regular_by_search/" + club + url;

  return FetchGetDataWithAuthNEW(url);
}

